module.exports = __webpack_public_path__ + "static/media/vehicle_vial.40e96bd3.svg";